import Swal from 'sweetalert2/dist/sweetalert2.js';
import { storeWishlistItem, removeWishlistItem, showTooltip } from '../project/favourites.js';

// General mixin for shared functionality among Vue instances
const mixin = {
    methods: {
        // Simple capitalize function.
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        // Simple whitespace strip function.
        strip(value) {
            if (!value) return '';
            value = value.toString();
            return value.replace(/\s/g, '');
        },
        // Simple date object handler.
        toDateObj(dateString) {
            return new Date(dateString);
        },
        // Simple date string handler.
        toDateFullStr(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, { timeZone: 'Europe/Amsterdam' });
        },
        toDateStr(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Amsterdam' });
        },
        toDateLongStr(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, { weekday: 'long', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Europe/Amsterdam' });
        },
        toTimeStr(dateString, culture) {
            return new Date(dateString).toLocaleTimeString(culture, { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' });
        },
        toCurrency(amount, culture, currency) {
            return new Intl.NumberFormat(culture, { style: 'currency', currency: currency }).format(amount);
        },
        // Simple array reverser.
        reverse(array) {
            return [...array].reverse();
        },
        // add event to wishlist 
        addWishlistItem(e) {
            let obj = e.currentTarget;
            if (obj.classList.contains('is-active')) {
                Swal.fire({
                    scrollbarPadding: false,
                    title: wishlistRemoveConfirm,
                    html: wishlistRemoveTxt1 + ' <b>' + obj.dataset.productiontitle + '</b> - <i>' + obj.dataset.productionsubtitle + '</i> ' + wishlistRemoveTxt2,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: wishListCancel,
                    confirmButtonText: wishlistRemoveTxt1
                }).then((result) => {
                    if (result.isConfirmed) {
                        removeWishlistItem(obj.dataset.eventid);
                    }
                });
            } else {
                storeWishlistItem(obj);
            }
        },
        // remove event from wishlist
        removeFromWishlist(id, title, subtitle) {
            Swal.fire({
                scrollbarPadding: false,
                title: wishlistRemoveConfirm,
                html: wishlistRemoveTxt1 + ' <b>' + title + '</b> <i>' + subtitle + '</i> ' + wishlistRemoveTxt2,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: wishListCancel,
                confirmButtonText: wishlistRemoveTxt1
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('removeFavorite', id);
                }
            });
        },
        // General debounce function for reducing unnecessary API calls.
        debounce(cb, delay = 500) {
            let timeout;
            return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay)}
        }
    }
}

export default mixin;
